/* Shared by styling sections only. Fetch native pagination before sorting/filtering. */
if (!customElements.get('andcharlie-styling-feed')) {
  customElements.define('andcharlie-styling-feed', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.loadFeed(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async loadFeed(signal) {
      const grid = this.querySelector('.ac-feed-grid');
      if (!grid) return;
      const status = this.querySelector('[data-ac-feed-status]');
      let next = this.querySelector('[data-ac-next]');
      const visited = new Set();
      try {
        while (next && !signal.aborted) {
          if (status) status.textContent = 'スタイリングを読み込んでいます';
          const url = new URL(next.href, location.href);
          const current = new URL(location.href);
          // Preserve theme preview / alternate template context, never share it publicly.
          for (const key of ['preview_theme_id', 'view']) {
            if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          }
          url.searchParams.set('section_id', this.dataset.sectionId);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid pagination');
          visited.add(url.href);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Pagination unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = [...doc.querySelectorAll(this.localName)].find(el => el.dataset.sectionId === this.dataset.sectionId);
          const sourceGrid = source?.querySelector('.ac-feed-grid');
          if (!sourceGrid) throw new Error('Missing styling section');
          if (signal.aborted) return;
          grid.append(...sourceGrid.children);
          const nextPage = source.querySelector('[data-ac-next]');
          if (nextPage) next.href = nextPage.getAttribute('href');
          else { next.remove(); next = null; }
        }
        if (signal.aborted) return;
        const cards = [...grid.children];
        cards.sort((a, b) => (Date.parse(b.dataset.posted) || 0) - (Date.parse(a.dataset.posted) || 0));
        grid.append(...cards);
        const limit = Number(this.dataset.limit) || cards.length;
        cards.forEach((card, index) => { card.hidden = index >= limit; });
        if (status) status.textContent = '';
        const total = this.querySelector('[data-ac-feed-total]');
        if (total) total.textContent = `${cards.length} ${cards.length === 1 ? 'look' : 'looks'}`;
        const empty = this.querySelector('[data-ac-empty-feed]');
        if (empty) empty.hidden = cards.length > 0;
        if (this.hasAttribute('data-ac-hide-empty')) this.hidden = cards.length === 0;
        this.afterLoad?.(signal);
        this.dispatchEvent(new CustomEvent('ac:styling-loaded', { bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (status) status.textContent = '続きの読み込みができませんでした。次のスタイリングを見るリンクからご覧ください。';
        // Native next-page link remains usable; do not advertise incomplete filters.
      }
    }
  });
}
